import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SearchBox from './SearchBox';
export default function AutoCompleteSearch({ onSelect, onSearch, renderItem, items, placeholder, clearOnSelect, getItemValue, }) {
    const [searchText, setSearchText] = useState('');
    function clear() {
        setSearchText('');
    }
    return (React.createElement(SearchBox, { items: items, value: searchText, clear: clear, clearOnSelect: clearOnSelect, search: onSearch, placeholder: placeholder, onSelect: onSelect, renderItem: renderItem, nGramLength: 3, getItemValue: getItemValue }));
}
AutoCompleteSearch.propTypes = {
    onSelect: PropTypes.func.isRequired,
    items: PropTypes.array.isRequired,
    renderItem: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    clearOnSelect: PropTypes.bool,
};
AutoCompleteSearch.defaultProps = {
    placeholder: 'Provide a placeholder',
    clearOnSelect: false,
};
